import $ from 'jquery';
import Parallax from './Parallax';
import BackgroundImage from './BackgroundImage';

export default class Hero {
  constructor(element) {
    this.element = element;
    this.$element = $(this.element);
    this.enhance();
    this.ready();
  }

  enhance() {
    this.$element.find('.node-upper-image').each((i, element) => {
      element.BackgroundImage = new BackgroundImage(element);
      element.Parallax = new Parallax(element);
    });
  }

  ready() {
    return this.$element.addClass('ready');
  }
}
